import { isEmpty } from 'lodash';

import removeMask from './removeMask';

const maskFieldValidator = (rule, value) => {
  const realValue = removeMask(String(value));

  if (isEmpty(realValue)) {
    // callback();
    return Promise.resolve();
  }

  const { min, max, message } = rule;

  if (realValue.length < min || realValue.length > max)
    return Promise.reject(new Error(message));

  return Promise.resolve();
};

export default maskFieldValidator;
